import { render, staticRenderFns } from "./ModuleList.vue?vue&type=template&id=f86311f2&"
import script from "./ModuleList.vue?vue&type=script&lang=ts&"
export * from "./ModuleList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports